import { useQuery } from "@tanstack/react-query";

import { meQueryOptions } from "./meQueryOptions";

// Текущий пользователь. У гостя — ошибка `ApiError` со статусом 401.
export const useCurrentUser = () => useQuery(meQueryOptions());
